import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Modal} from 'shells/modal/modal';
import {OnboardingPage} from 'shells/onboarding-page/onboarding-page';

import {HelpBodyClosedLeadEmailMarketing} from './help-body-closed-lead-email-marketing';
import {HelpGraphicClosedLeadEmailMarketing} from './help-graphic-closed-lead-email-marketing';

type Props = {
    onClose: () => void;
    isOpen: boolean;
};

export class HelpClosedLeadEmailMarketing extends React.PureComponent<Props> {
    render() {
        return (
            <div>
                <Modal
                    isOpen={this.props.isOpen}
                    onClose={this.props.onClose}
                    noPadding={true}
                    closeButton={false}
                    preventBodyScroll={false}
                    maxHeight={500}
                >
                    <OnboardingPage
                        type='singlePage'
                        bodyComponent={<HelpBodyClosedLeadEmailMarketing />}
                        artBackgroundColor={colors.plumDk}
                        artImage={<HelpGraphicClosedLeadEmailMarketing />}
                        buttonText='Done'
                        onClose={this.props.onClose}
                    />
                </Modal>
            </div>
        );
    }
}
